import './index.scss';


import { Icon } from '../../components/icon';
import Mala from "../../assets/icons/ico-mala.svg"
import Transfer from "../../assets/icons/ico-transfer.svg"
import Taxa from "../../assets/icons/ico-taxa.svg"

export const OperacoesCobalt = () => {

    return (

        <div className='container-page3'>
            <div className='page3-title'>
                Porque operar com a Cobalt?
            </div>

            <div className='subcontainer1-page3'>

                <div className='coluna1-page3'>
                    <div className='circle-page3'>
                        <Icon icon={Mala} size={30}/>
                    </div>
                    <div className='title-colun-page3'>
                        <h1> Consultoria cambial </h1>
                    </div>
                    <div className='text-colun-page3'>
                        <p>
                            Conseguimos entender e executar com
                            perfeição aos operações que envolvem
                            exposição em commodities e questões
                            atreladas à elas como: sanções, altas taxas,
                            negociação com países sensíveis.
                        </p>
                    </div>
                </div>

                <div className='coluna1-page3'>
                    <div className='circle-page3'>
                        <Icon icon={Transfer} size={30}/>
                    </div>
                    <div className='title-colun-page3'>
                        <h1> Área cambial externa </h1>
                    </div>
                    <div className='text-colun-page3'>
                        <p>
                            Colocamos nossas áreas mais estratégicas
                            para trabalhar para sua empresa como
                            BackOffice, Middle Ofice e Mesa Trader e
                            Tesouraria.
                        </p>
                    </div>
                </div>

                <div className='coluna1-page3'>
                    <div className='circle-page3'>
                        <Icon icon={Taxa} size={30}/>
                    </div>
                    <div className='title-colun-page3'>
                        <h1> Taxas competitivas </h1>
                    </div>
                    <div className='text-colun-page3'>
                        <p>
                            Além de termos um algoritmo de
                            arbitragem que verifica a melhor taxa e
                            condição em nossos players liquidantes,
                            somos transparentes: sem taxas escondidas.
                        </p>
                    </div>
                </div>

            </div>

            <a className='btn-style button-operar'  href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>

            <div className='faixa-page3'>

                <div className='colun-faixa-page3'>
                    <h1> + 100 MM </h1>
                    <p> Movimentados por mês </p>
                </div>

                <div className='colun-faixa-page3'>
                    <h1> + 50 </h1>
                    <p> Segmentos atendidos </p>
                </div>

                <div className='colun-faixa-page3'>
                    <h1> + 10 </h1>
                    <p> Instituições financeiras integradas </p>
                </div>

                <div className='colun-faixa-page3'>
                    <h1> + 30 </h1>
                    <p> CORBAN integralizados </p>
                </div>

            </div>
        </div>
    )

}
